import styled, { css } from 'styled-components';
import { InputProps, sharedStyles } from '../Input';
import { DISABLED_INPUT_COLOR } from 'shared/consts';

export const TextareaField = styled.textarea<InputProps>`
	${sharedStyles}
	padding-left: 12px;
	height: ${props => props.$height || '73px'};
	resize: none;
	padding-top: 8px;
  transition: all 0.3s ease 0s;
  ${props => props.$hide && css`display: none;`}
  ${props => props.$pen && css`pointer-events: none;`}

	&:disabled {
		background-color: ${DISABLED_INPUT_COLOR};
		color: white;
		border-color: ${DISABLED_INPUT_COLOR};
	}
`;
